import React, { FC, Fragment } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { OrganizationContact } from 'models/contact';
import FormattedAddress from 'components/shared/address/formatted-address.component';

type InvoiceAddressBoxProps = {
    title: string;
    name?: string;
    contact?: OrganizationContact;
};
const InvoiceAddressBox: FC<InvoiceAddressBoxProps> = ({ title, name, contact }: InvoiceAddressBoxProps) => {
    return (
        <Paper variant="outlined">
            <Box p={1}>
                {name && contact ? (
                    <Fragment>
                        <Typography variant="subtitle2">{title}</Typography>
                        <Box>{name}</Box>
                        <Box>
                            <FormattedAddress address={contact?.address} />
                        </Box>
                    </Fragment>
                ) : undefined}
            </Box>
        </Paper>
    );
};

export default InvoiceAddressBox;
